import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
// import {AmountTdWidth} from "../../../Table/Common/AmountTd";
import {Helper} from "../../../../containers/AppPage/Reports/Ledger/helper";
import {CustomFieldHelper} from "../../../../shared/CustomFieldHelper";

function getColumns(props, fields) {
    const { currencySymbol, companyCurrencyCode } = props;
    return [
        {
            key: 'date',
            dataKey: 'date',
            title: t`Date`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderDate,
        },
        {
            key: 'number',
            dataKey: 'number',
            title: t`No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber,
        },
        {
            key: 'type',
            dataKey: 'type',
            title: t`Type`,
            width: 0,
            flexGrow: 15,
            cellRenderer: Helper.renderType,
        },
        {
            key: 'contact_name',
            dataKey: 'contact_name',
            title: t`Contact`,
            width: 0,
            flexGrow: 16,
            cellRenderer: Helper.renderContact,
        },
        {
            title: t`Contact Code`,
            dataIndex: 'contact_code',
            key: 'contact_code',
            sorter: true,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderContactCode,
        },
        {
            key: 'number2',
            dataKey: 'number2',
            title: t`Reference No.`,
            width: 0,
            flexGrow: 14,
            cellRenderer: Helper.renderNumber2,

        },
        {
            key: 'payment_method',
            dataKey: 'payment_method',
            title: t`Payment Method`,
            width: 0,
            flexGrow: 16,
            cellRenderer: Helper.renderPaymentMethod,
        },
        {
            key: 'description',
            dataKey: 'description',
            title: t`Description`,
            width: 0,
            flexGrow: 23,
            cellRenderer: Helper.renderDescription,
        },
        {
            key: 'amount',
            dataKey: 'amount',
            title: t`Amt`,
            align: 'right',
            width: 80,
            flexGrow: 12,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.amount, rowData.currency_symbol),
        },
        {
            key: 'base_amount',
            dataKey: 'base_amount',
            title: companyCurrencyCode ? t`Amt ${companyCurrencyCode}` : t`Home Amt`,
            align: 'right',
            width: 70,
            flexGrow: 10,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.base_amount, currencySymbol),
        },
        {
            key: 'apply_amount',
            dataKey: 'apply_amount',
            title: t`Apply Amt`,
            align: 'right',
            width: 80,
            flexGrow: 12,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.apply_amount,
                rowData.currency_symbol,
                false),
        },
        {
            key: 'base_apply_amount',
            dataKey: 'base_apply_amount',
            title: companyCurrencyCode ? t`Apply Amt ${companyCurrencyCode}` : t`Home Apply Amt`,
            align: 'right',
            width: 80,
            flexGrow: 12,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.base_apply_amount,
                currencySymbol,
                false),
        },
        {
            key: 'balance_amount',
            dataKey: 'balance_amount',
            title: t`Balance Amt`,
            align: 'right',
            width: 80,
            flexGrow: 12,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.balance_amount,
                rowData.currency_symbol,
                false),
        },
        {
            key: 'base_balance_amount',
            dataKey: 'base_balance_amount',
            title: companyCurrencyCode ? t`Balance Amt ${companyCurrencyCode}` : t`Home Balance Amt`,
            align: 'right',
            width: 80,
            flexGrow: 12,
            cellRenderer: ({ rowData }) => Helper.renderAmount(rowData.base_balance_amount,
                currencySymbol,
                false),
        },
        {
            key: 'created_at',
            dataKey: 'created_at',
            title: t`Created`,
            width: 0,
            flexGrow: 25,
            cellRenderer: Helper.renderCreatedAt,
        },

        // custom fields
        ...CustomFieldHelper.getColumnsBaseTable(fields.transaction),
    ];
}

export default {
    storageKey: StorageKey.report_official_receipt_summary,
    getReportLabel: () => t`Official Receipt Summary`,
    required: [
        'date',
        'number',
        'base_amount',
    ],
    defaulto: [
        'type',
        'contact_name',
        'description',
    ],
    getColumns,
};
